import { render } from "./PurpleHeader.vue?vue&type=template&id=f3e9f1c2"
import script from "./PurpleHeader.vue?vue&type=script&lang=js"
export * from "./PurpleHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__